/**
 * Utility function to handle redirecting from Painter 2.0 to Painter 1.0 (legacy).
 *
 * @param reason - The reason for the redirect
 */
export const redirectToLegacyPainter = (reason) => {
    const queryString = window.location.search;
    const searchParams = new URLSearchParams(queryString);
    // Determine marketplace based on marketplaceId parameter
    const isCanada = searchParams.get('marketplaceId') === 'CA' || window.location.hostname.includes('amazon.ca');
    const baseUrl = reason === 'missing_auth'
        ? 'https://web.shop-external.amazon'
        : `https://shop.social.amazon.${isCanada ? 'ca' : 'com'}`;
    // Add fallback parameter and preserve all current query parameters
    searchParams.set('fallbackFromPainter20', 'true');
    searchParams.set('fallbackReason', reason);
    if (reason === 'missing_auth') {
        searchParams.set('dexp', 'missingAuthIn20');
    }
    const redirectUrl = `${baseUrl}${location.pathname}?${searchParams.toString()}`;
    window.location.href = redirectUrl;
};
